module.exports = __webpack_public_path__ + "img/doc.8afa325f.svg";